import { useEffect } from 'react';

import { useParams } from 'react-router';

import useAuth from '@/hooks/useAuth';

import Constants from '../../constants/index';

import PdfDownload from './PdfDownload';

import { useAmplitudeTrack } from '@/amplitude/useAmplitude';

const PrintView = () => {
  const params = useParams<{ documentId: string }>();
  const { documentId } = params;
  const track = useAmplitudeTrack();
  const { data: auth } = useAuth();
  const locations = auth?.locations;

  useEffect(() => {
    if (track !== null) {
      track('document_print', {
        document_id: documentId ?? 'empty',
        datetime: Date().toLocaleString(),
      });
    }
  }, [track, documentId, locations]);

  return (
    <div className="bg-surface-gray absolute top-0 left-0 z-2 min-h-screen w-screen">
      <PdfDownload
        url={`${Constants.PATHWAY_API_URL}/${Constants.PATHWAY_API.BINARY_PATH_NAME}/${documentId}`}
      />
    </div>
  );
};

export default PrintView;
